import { NavLink, useLocation, useNavigate } from "react-router-dom";
import ProfileStatusPopUp from "./ProfileStatusPopUp";
import { useEffect, useState } from "react";
import img from "../../assets/sign-in-back.svg";
import { handleError, handleSuccess } from "../../Utils";
import { useAuth } from "../../provider/authProvider";
import {
  getProfileRole,
  mentorLogin,
  userLogin,
} from "../../ApiServices/ApiServices";

const Login = () => {
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const { setToken } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [showPopUp, setShowPopUp] = useState(false);
  const [popUpTitle, setPopUpTitle] = useState("");
  const [popUpMessage, setPopUpMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const from = location.state?.from || "/dashboard";

  useEffect(() => {
    document.title = "Codequeue - Login";
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await getProfileRole(userId);
      if (res.status === "hold") {
        setPopUpTitle("Profile On Hold");
        setPopUpMessage(
          "Your profile is currently on hold due to unusual activity. It will be reactivated automatically after 48 hours. If you have any questions, please contact support."
        );
        setShowPopUp(true);
        return;
      }

      if (res.status === "suspended") {
        setPopUpTitle("Profile Suspended");
        setPopUpMessage(
          "Your profile has been permanently suspended due to violations of our policies. For further assistance or to appeal, please reach out to support."
        );
        setShowPopUp(true);
        return;
      }

      if (res.status === "deleted") {
        setPopUpTitle("Profile Deleted");
        setPopUpMessage(
          "Your profile has been deleted as per your request or due to non-compliance with our policies. If you believe this is an error, please contact support."
        );
        setShowPopUp(true);
        return;
      }
      const role = res.role;
      // checking if profile role is user or mentor
      if (role === "user") {
        const response = await userLogin(userId, password);
        const { jwtToken, message, name, success } = response;

        if (success) {
          handleSuccess(message);
          setToken(jwtToken);
          localStorage.setItem("loggedInUser", name);
          setUserId("");
          setPassword("");
          navigate(from);
        }
      }
      if (role === "mentor") {
        const response = await mentorLogin(userId, password);

        const { jwtToken, message, name, success } = response;

        if (success) {
          handleSuccess(message);
          setToken(jwtToken);
          localStorage.setItem("loggedInUser", name);
          setUserId("");
          setPassword("");
          navigate(from);
        }
      }
    } catch (error) {
      return handleError(error?.response?.data?.message);
    }finally{
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center flex-wrap py-2 mt-6 login">
      {showPopUp && (
        <ProfileStatusPopUp
          title={popUpTitle}
          message={popUpMessage}
          setUserId={setUserId}
          setPassword={setPassword}
          onClose={() => setShowPopUp(false)}
        />
      )}
      <div className="flex flex-col gap-4 w-[30rem] py-10 px-8 left">
        <div>
          <form
            onSubmit={handleSubmit}
            className="flex flex-col gap-3 py-8 md:px-8 login-form"
          >
            <div className="flex flex-col form-group">
              <label htmlFor="email" className="font-bold text-[15px]">
                Email/Phone:
              </label>
              <input
                type="text"
                id="userId"
                value={userId}
                placeholder="Email/Phone"
                onChange={(e) => setUserId(e.target.value.trim().toLowerCase())}
                className="h-10 rounded border border-gray-300 font-medium p-2"
              />
            </div>

            <div className="flex flex-col form-group">
              <label htmlFor="password" className="font-bold text-[15px]">
                Password:
              </label>
              <input
                type="password"
                id="password"
                value={password}
                placeholder="Password"
                onChange={(e) => setPassword(e.target.value.trim())}
                className="h-10 rounded border border-gray-300 font-medium p-2"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="primary-btn submit-btn mt-4 bg-blue-500 text-white font-semibold py-2 rounded hover:bg-blue-600"
            >
              {loading ? <div className="spinner" /> : "Login"}
            </button>
            <NavLink
              to={"/signup"}
              className="forgot-password hover text-center text-blue-500 hover:underline"
            >
              Don't have an account?
            </NavLink>
          </form>
        </div>
        <div className="divider flex items-center">
          <hr className="divider-line flex-1 h-px bg-gray-300 border-none" />
        </div>
        <NavLink
          to={"/forgot-password"}
          className="forgot-password hover text-center text-blue-500 hover:underline"
        >
          Forgot Password
        </NavLink>
      </div>

      <div className="right w-[30rem] pt-6 overflow-hidden">
        <img
          src={img}
          alt="Img"
          className="w-[30rem] max-w-full object-cover"
        />
      </div>
    </div>
  );
};

export default Login;
